import { UserProfileControllerImpl } from "../../../../modules/account/business/impl/controllers";
const controller = new UserProfileControllerImpl();

export const userDataPanelFields = {
    trade_name: {
        label: "tradeName",
        placeholder: "tradeName",
        ariaDescribedby: "tradeNameHelpBlock",
        helpBlock: "tradeNameHelp",
        className: "text-capitalize",
        subscriber: "subscriber"
    },
    phone: {
        fieldType: "tel",
        label: "phone",
        placeholder: "phoneExample",
        ariaDescribedby: "phoneHelpBlock",
        helpBlock: "phoneHelp",
        mask: "(99) 9-9999-9999",
        required: "required"
    },
    business: {
        fieldType: "tel",
        label: "businessPhone",
        placeholder: "businessPhone",
        ariaDescribedby: "businessPhoneHelpBlock",
        phone: "phone",
        helpBlock: "businessPhoneHelp",
        required: "required",
        subscriber: "subscriber"

    },
    document: {
        fieldType: "tel",
        label: "document",
        placeholder: "documentExample",
        ariaDescribedby: "documentHelpBlock",
        helpBlock: "documentHelp",
        mask: "999.999.999-99",
        required: "required",
        subscriber: "subscriber"
    },
    email: {
        fieldType: "email",
        label: "email",
        placeholder: "emailDescription",
        ariaDescribedby: "emailHelpBlock",
        helpBlock: "emailHelp",
        required: "required"
    },
    zipcode: {
        fieldType: "tel",
        label: "zipcode",
        placeholder: "zipcodeExample",
        ariaDescribedby: "zipcodeHelpBlock",
        helpBlock: "zipcodeHelp",
        mask: "99.999-999",
        action: {
            when: "onBlur",
            method: controller.getAddressDataByZipcode.bind(controller),
            fillUp: {
                address: "logradouro",
                neighborhood: "bairro",
                city: "localidade",
                state: "uf",
            },
        },
        required: "required",
        subscriber: "subscriber"
    },
    address: {
        label: "address",
        placeholder: "addressExample",
        ariaDescribedby: "addressHelpBlock",
        helpBlock: "addressHelp",
        className: "text-capitalize",
        required: "required",
        subscriber: "subscriber"
    },
    number: {
        label: "number",
        placeholder: "number",
        ariaDescribedby: "numberHelpBlock",
        helpBlock: "numberHelp",
        required: "required",
        subscriber: "subscriber"
    },
    neighborhood: {
        label: "neighborhood",
        placeholder: "neighborhood",
        ariaDescribedby: "neighborhoodHelpBlock",
        helpBlock: "neighborhoodHelp",
        className: "text-capitalize",
        required: "required",
        subscriber: "subscriber"
    },
    city: {
        label: "city",
        placeholder: "city",
        ariaDescribedby: "cityHelpBlock",
        helpBlock: "cityHelp",
        className: "text-capitalize",
        required: "required",
        subscriber: "subscriber"
    },
    state: {
        label: "state",
        placeholder: "stateExample",
        ariaDescribedby: "stateHelpBlock",
        helpBlock: "stateHelp",
        maxLength: "2",
        regex: "/[^0-9]/g",
        className: "text-uppercase",
        required: "required",
        subscriber: "subscriber"
    }
}